import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglechromeComponent } from './simple-icons-googlechrome.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglechromeComponent ],
    exports:      [ SimpleIconsGooglechromeComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglechromeModule {}
